import { gql } from 'graphql-tag';

export const GET_MYSTAGE_LESSON_TOKEN = gql`
  query mystageLesson($student_book_id: Int!) {
    mystage_lesson(student_book_id: $student_book_id) {
      token
    }
  }
`;
